import * as tslib_1 from "tslib";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import StreamedList from '../../StreamedList';
import { StreamType } from '../../Stream';
import CoreIconSmall from '../../Icons/CoreIconSmall';
import Popup from '../../Popup';
import LoadingIndicator from '../../LoadingIndicator';
import { IconSize } from '../../Icons/IconWrap';
import BackgroundThumb from './BackgroundThumb';
import s from './BackgroundPickerPopup.scss';
export var BackgroundPickerPopup = function (_a) {
    var streamId = _a.streamId, backgrounds = _a.backgrounds, requestClose = _a.requestClose, canUseCore = _a.canUseCore, currentBackgroundId = _a.currentBackgroundId, onBackgroundPreviewed = _a.onBackgroundPreviewed, onBackgroundPicked = _a.onBackgroundPicked, deviation = _a.deviation, isFetching = _a.isFetching, theme = _a.theme;
    var t = useTranslation().t;
    var commonThumbProps = {
        theme: theme,
        canUseCore: canUseCore,
        onBackgroundPicked: function (backgroundId) {
            return onBackgroundPicked(deviation, backgroundId);
        },
        onBackgroundPreviewed: onBackgroundPreviewed,
    };
    return (React.createElement(Popup, { isOpen: true, onRequestClose: requestClose, className: s['popover'], contentClassName: s['root'], closeBtnClassName: s['close-button'], overlayClassName: s['overlay'], withCloseButton: true },
        React.createElement("div", { className: s['header'] }, t('deviation.backgrounds.choose')),
        React.createElement(StreamedList, { wrapperClassName: s['list-wrapper'], className: s['list'], streamId: streamId, streamType: StreamType.WITH_OFFSET },
            backgrounds && backgrounds.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(BackgroundThumb, tslib_1.__assign({ key: "default", background: { backgroundId: -1 }, isSelected: typeof currentBackgroundId === 'undefined' }, commonThumbProps)),
                backgrounds.map(function (bg) { return (React.createElement(BackgroundThumb, tslib_1.__assign({ key: bg.backgroundId, background: bg, isSelected: bg.backgroundId === currentBackgroundId }, commonThumbProps))); }))),
            isFetching && (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] }))),
        React.createElement("div", { className: s['footer'] }, !canUseCore && (React.createElement("div", { className: s['core-upsell'] },
            React.createElement(CoreIconSmall, { size: IconSize.SMALL, className: s['core-icon'] }),
            React.createElement(Trans, { i18nKey: "deviation.backgrounds.becomeCore" },
                React.createElement("strong", { className: s['become-core'] }, "Become core"),
                "to access all the backgrounds for your art"))))));
};
export default BackgroundPickerPopup;
//# sourceMappingURL=BackgroundPickerPopup.js.map